var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "pftm" },
    [
      _c("div", { staticClass: "pftm__flex-row" }, [
        _vm.product.vendor
          ? _c(
              "a",
              {
                staticClass: "h5 pftm__vendor-link",
                attrs: { href: _vm.getCollectionLink(_vm.product.vendor) }
              },
              [_vm._v(_vm._s(_vm.product.vendor))]
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "pftm__flex-row" }, [
        _c("h1", { staticClass: "pdp-product-title" }, [
          _vm._v(_vm._s(_vm.product.title))
        ])
      ]),
      [
        _c("div", { staticClass: "pftm__flex-row" }, [
          _vm.skuText && _vm.skuText.length > 0
            ? _c("span", { staticClass: "pdp__sku pftm__sku-mobile body-sm" }, [
                _vm._v("Item #: " + _vm._s(_vm.skuText))
              ])
            : _vm._e()
        ])
      ],
      _vm.settings.upsellCardProduct.handle
        ? _c("product-upsell-card", {
            staticClass: "u-hidden-mobile-only margin-top",
            attrs: {
              product: _vm.settings.upsellCardProduct,
              heading: _vm.customFields.d2_upsell_heading,
              description: _vm.customFields.d2_upsell_description,
              callout: _vm.customFields.d2_upsell_alert_text
            }
          })
        : _vm._e(),
      !_vm.isCallForPrice(_vm.product)
        ? _c("div", { staticClass: "pftm__price-container" }, [
            _vm.variant
              ? _c(
                  "span",
                  {
                    staticClass: "pftm__price pdp-price",
                    class:
                      _vm.prices.price < _vm.prices.compare_at_price
                        ? "pftm__price--accent"
                        : ""
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("Now: ")
                    ]),
                    _vm._v(
                      _vm._s(_vm._f("moneyWithoutDecimals")(_vm.prices.price))
                    )
                  ]
                )
              : _vm._e(),
            _vm.variant && _vm.prices.price < _vm.prices.compare_at_price
              ? _c(
                  "span",
                  {
                    staticClass:
                      "pftm__price-compare pdp-price pdp-price-compare"
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("Was: ")
                    ]),
                    _vm._v(
                      _vm._s(
                        _vm._f("moneyWithoutDecimals")(
                          _vm.prices.compare_at_price
                        )
                      )
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "span",
              {
                staticClass: "pftm__price-text pdp-price",
                style: _vm.priceAdditionalTextStyles
              },
              [_vm._v(_vm._s(_vm.priceAdditionalText))]
            ),
            _c("div", { staticClass: "affirm-holder" }, [
              _c(
                "div",
                {
                  staticClass: "affirm-as-low-as",
                  attrs: {
                    "data-page-type": "product",
                    "data-affirm-color": "blue",
                    "data-amount": _vm.prices.price
                  }
                },
                [
                  _vm._v("Starting at 0% APR at"),
                  _c(
                    "span",
                    {
                      staticClass: "affirm-ala-price",
                      attrs: { "data-amount": _vm.variant.price }
                    },
                    [_vm._v("/mo with")]
                  ),
                  _c("span", {
                    staticClass:
                      "__affirm-logo __affirm-logo-blue __ligature__affirm_full_logo__"
                  })
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm.additionalText
        ? _c(
            "div",
            {
              staticClass: "pftm__metafield-container",
              style: _vm.additionalTextStyles
            },
            [
              _c("span", { staticClass: "body-sm pftm__metafield-text" }, [
                _vm._v(_vm._s(_vm.additionalText))
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }